import React, { useContext, useEffect, useState } from 'react';

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

import QuoterContext from '../../context/QuoterContext';

import AppDownload from '../AppDownload';
import Button from '../commons/Button';
import StopErrorModal from '../modals/StopErrorModal';

import axiosInstanceWee from '../../core/api-config';

import {
  logProgressInVincoBack, scrollToFormStart,
} from '../../core/helper-functions';

import { FORM6_SCHEMA } from '../../constants/validation-schemas';
import {
  FORM6_SUBMIT_URL,
  GET_INVOICE_DATA,
  PAYMENT_COMPLEMENT_STAMP,
  STAMP_INVOICE_URL,
  GENERATE_PAYMENT_COMPLEMENT_FILE,
  GENERATE_INVOICE_FILES_URL,
  SEND_INVOICE_BY_EMAIL_URL,
  CONFIRM_FISCAL_DATA_URL,
  GET_TAX_REGIME_LIST,
  EXIT_URL,
} from '../../constants/constants';

const Form6 = () => {
  const emtpyOptionJSX = <option key="void" value="">Elegir</option>;
  const formValidationSchema = Yup.object().shape(FORM6_SCHEMA);
  const { quoterContextValues, setQuoterContextValues } = useContext(QuoterContext);
  const formInitialValues = quoterContextValues.form5.samePerson === 'yes'
    ? {
      taxRegime: quoterContextValues.form5.taxRegime || '',
      postalCode: quoterContextValues.form5.postalCode || '',
      rfc: quoterContextValues.form5.rfc || '',
      email: quoterContextValues.form5.email || '',
    }
    : {
      taxRegime: quoterContextValues.form5.taxRegime || '',
      postalCode: quoterContextValues.form5.insuredPostalCode || '',
      rfc: quoterContextValues.form5.insuredRfc || '',
      email: quoterContextValues.form5.insuredEmail || '',
    };
  const [isInoviceFormOpen, setIsInvoiceFormOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState(false);
  const [errorModalTitle, setErrorModalTitle] = useState(false);
  const [hideInvoiceButton, setHideInvoiceButton] = useState(false);
  const [taxRegimeList, setTaxRegimeList] = useState([]);

  useEffect(() => {
    axiosInstanceWee
      .post(GET_TAX_REGIME_LIST, new URLSearchParams({ Busqueda: '' }))
      .then(({ data }) => {
        const newList = data.dsRespuesta.Datos.map((p) => {
          return (
            <option
              key={p.c_RegimenFiscal}
              value={p.c_RegimenFiscal}>
              {p.Descripción}
            </option>
          );
        });
        newList.unshift(emtpyOptionJSX);
        if (!taxRegimeList.length) {
          setTaxRegimeList(newList);
        }
      });
    scrollToFormStart();
  }, []);

  const closeModalHandle = () => {
    setErrorModalMessage('');
  };

  const toggleInvoiceForm = () => {
    setIsInvoiceFormOpen(!isInoviceFormOpen);
  };

  // WeeAmae_FacturaEmail(idFactura, xUserinsert, isgenerica);
  // API/api/Amae/SendEmail_DatosFacturacionAmae
  const sendInvoiceByEmail = (idFactura, xUserinsert, isGenericInvoice) => {
    return axiosInstanceWee
      .post(
        SEND_INVOICE_BY_EMAIL_URL,
        new URLSearchParams({
          idLiga: quoterContextValues.ids.idTramite,
          idFactura,
          XuserId: xUserinsert,
          isGenerica: isGenericInvoice,
        }),
      );
  };

  // function ConfirmDatosFiscales(isintento = 1)
  // Api/api/Amae/UpdateDatosFiscalesByTramitebroker
  const confirmFiscalData = async (values, idTramite, isAttempt = 1) => {
    return axiosInstanceWee.post(
      CONFIRM_FISCAL_DATA_URL,
      new URLSearchParams({
        idTramite,
        CodigoPostal: values.postalCode,
        RegimenFisc: values.taxRegime || 0,
        RFC: values.rfc,
        Email: values.email,
        idRazonSocial: idTramite,
        IntentoFactura: isAttempt,
      }),
    );
  };

  // GenerarArchivosAMAE(idFactura, xUserinsert, isComplemento, isgenerica);
  // "api/PDF/Facturacion/viewFacturaAmae.aspx?facturaid=" + idFactura
  const generateAmaeFiles = async (idFactura, xUserinsert, complement, isGenericInvoice) => {
    const fullURL = `${GENERATE_INVOICE_FILES_URL}${idFactura}`;
    return axiosInstanceWee
      .get(fullURL)
      .then(() => {
        if (parseInt(complement, 10) === 0) {
          sendInvoiceByEmail(idFactura, xUserinsert, isGenericInvoice);
        }
      });
  };

  const generatePaymentComplementFile = (idFactura, xUserinsert, isGenericInvoice = 0) => {
    const fullURL = `${GENERATE_PAYMENT_COMPLEMENT_FILE}${idFactura}`;
    axiosInstanceWee.get(fullURL)
      .then(() => {
        sendInvoiceByEmail(idFactura, xUserinsert, isGenericInvoice);
      });
  };

  // ComplementoPagoAMAE(idFactura, xUserinsert, isgenerica);
  // API/api/Amae/GenerarComplementoPago
  const paymentComplementStamp = (idFactura, xUserinsert, isGenericInvoice = 0) => {
    axiosInstanceWee
      .post(
        PAYMENT_COMPLEMENT_STAMP,
        new URLSearchParams({
          idFactura,
          idRazonSocial: xUserinsert,
        }),
      )
      .then(({ data }) => {
        if (data.Mensaje === 'Timbrado exitoso' && data.IsExists) {
          generatePaymentComplementFile(idFactura, xUserinsert, isGenericInvoice);
        } else {
          logProgressInVincoBack(
            quoterContextValues.ids.idTramite,
            new Date(),
            6,
            0,
            '001',
            200,
            409,
            null,
            'Error in paymentComplementStamp [API/api/Amae/GenerarComplementoPago]',
          );
          setErrorModalMessage(true);
        }
      });
  };

  // API/api/WeeBroker/TimbrarFactura
  const getInvoiceStamp = async (values, idFactura, xUserinsert, complement) => {
    axiosInstanceWee
      .post(
        STAMP_INVOICE_URL,
        new URLSearchParams({
          idFactura,
          idRazonSocial: xUserinsert,
          tipoPersonaWee: 1,
          FacAmae: 1,
          tryBill: quoterContextValues.factura.intentosTimbrado,
        }),
      )
      .then(({ data }) => {
        if (data.Mensaje === 'Timbrado exitoso') {
          Promise
            .all([
              confirmFiscalData(values, quoterContextValues.ids.idTramite, 0),
              generateAmaeFiles(
                idFactura,
                xUserinsert,
                complement,
                data.Password === 'isGenerica' ? 1 : 0,
              ),
              parseInt(complement, 10) === 1
                ? paymentComplementStamp(idFactura, xUserinsert, data.Password === 'isGenerica' ? 1 : 0)
                : true,
            ]).then(() => {
              const newQuoterContext = {
                ...quoterContextValues,
                isAppLoading: false,
              };
              logProgressInVincoBack(
                quoterContextValues.ids.idTramite,
                new Date(),
                6,
                0,
                '002',
                200,
                200,
                null,
                'Proceso completado exitosamente',
              );
              setErrorModalTitle('¡Felicidades!');
              setQuoterContextValues(newQuoterContext);
              setErrorModalMessage('Se ha generado exitosasmente tu factura y te será enviada por correo electrónico.');
              setHideInvoiceButton(true);
            })
            .catch((err) => {
              const newQuoterContext = {
                ...quoterContextValues,
                isAppLoading: false,
              };
              logProgressInVincoBack(
                newQuoterContext.ids.idTramite,
                new Date(),
                6,
                0,
                '001',
                200,
                409,
                null,
                'Error in paymentComplementStamp [API/api/Amae/GenerarComplementoPago]',
              );
              setQuoterContextValues(newQuoterContext);
              setErrorModalMessage('Existe un error al generar o enviar tu factura. Por favor comunícate con servicio al cliente.');
              throw err;
            });
        } else {
          logProgressInVincoBack(
            quoterContextValues.ids.idTramite,
            new Date(),
            6,
            0,
            '001',
            200,
            409,
            null,
            'Error in getInvoiceStamp [API/api/WeeBroker/TimbrarFactura]',
          );
          setQuoterContextValues({
            ...quoterContextValues,
            isAppLoading: false,
          });
          setErrorModalMessage(data.Message || 'No se pudo completar la operción. Comunícate a servicio al cliente.');
          throw new Error('error in getInvoiceStamp [200] (API/api/WeeBroker/TimbrarFactura)');
        }
      });
  };

  const getInvoiceData = async (values) => {
    await axiosInstanceWee.post(
      GET_INVOICE_DATA,
      new URLSearchParams({
        idTramite: quoterContextValues.ids.idTramite,
      }),
    ).then(({ data }) => {
      if (data.NoFilas > 0) {
        getInvoiceStamp(
          values,
          data.dsRespuesta.Datos[0].idFactura,
          data.dsRespuesta.Datos[0].xUserInsert,
          data.dsRespuesta.Datos[0].isComplemento,
        );
      }
    });
  };

  const submitFiscalData = (values, isAttempt = 1) => {
    const valuesData = {
      idTramite: quoterContextValues.ids.idTramite,
      RegimenFisc: values.taxRegime,
      CodigoPostal: values.postalCode,
      RFC: values.rfc,
      Email: values.email,
      idRazonSocial: quoterContextValues.ids.idTramite,
      IntentoFactura: isAttempt,
    };

    const submitData = new URLSearchParams(valuesData);

    axiosInstanceWee
      .post(FORM6_SUBMIT_URL, submitData)
      .then(({ data }) => {
        if (data.NoFilas > 0) {
          getInvoiceData(values);
        }
      });
  };

  // function ConfirmDatosFiscales(isintento = 1)
  const formSubmitHandler = async (values) => {
    setQuoterContextValues({
      ...quoterContextValues,
      isAppLoading: true,
    });
    submitFiscalData(values, 1);
  };

  return (
    <div className="quoter-form -step-6">
      {errorModalMessage && (
        <StopErrorModal
          onClick={closeModalHandle}
          title={errorModalTitle || 'Error'}
          body={errorModalMessage} />
      )}
      <div className="result-panel">
        <h3>Folio de compra:</h3>
        <p>{quoterContextValues.poliza.folio}</p>
      </div>
      <div className="result-panel">
        <h3>Número de póliza</h3>
        <p>{quoterContextValues.poliza.numero}</p>
      </div>
      <p className="email-sent">Se te envió un correo electrónico con tu usuario</p>
      <AppDownload />
      <div className="form-buttons">
        <a href={EXIT_URL} className="btn -backward">Cerrar</a>
        {
          quoterContextValues.form5.wantInvoice === 'yes' && !hideInvoiceButton
            ? (
              <button
                onClick={toggleInvoiceForm}
                type="button"
                className="btn">
                {
                  isInoviceFormOpen ? 'Cierra formulario' : 'Genera aquí tu factura'
                }
              </button>
            )
            : ''
        }
      </div>
      {
        isInoviceFormOpen && !hideInvoiceButton
          ? (
            <Formik
              initialValues={formInitialValues}
              validationSchema={formValidationSchema}
              onSubmit={formSubmitHandler}
              validateOnMount>
              {({ errors, touched, isSubmitting, isValid, isValidating }) => {
                return (
                  <Form className="fields-invoice">
                    <div className="form-fields -invoice">
                      <p>
                        Es importante confirmar que tus datos sean correctos, así que
                        considera ingresar la información como aparece en tu constancia
                        fiscal.
                      </p>
                      <div className="field-row">
                        <div className="field -input">
                          <label htmlFor="taxRegime">Régimen Fiscal:</label>
                          {errors.taxRegime && touched.taxRegime && <div className="field-invalid">{errors.taxRegime}</div>}
                          {!errors.taxRegime && touched.taxRegime && <div className="field-valid">ok</div>}
                          <Field as="select" name="taxRegime">
                            {taxRegimeList}
                          </Field>
                        </div>
                        <div className="field -input">
                          <label htmlFor="postalCode">Código Postal:</label>
                          {errors.postalCode && touched.postalCode && <div className="field-invalid">{errors.postalCode}</div>}
                          {!errors.postalCode && touched.postalCode && <div className="field-valid">ok</div>}
                          <Field
                            name="postalCode"
                            maxLength="5"
                            type="text" />
                        </div>
                      </div>
                      <div className="field-row">
                        <div className="field -input">
                          <label htmlFor="rfc">RFC:</label>
                          {errors.rfc && touched.rfc && <div className="field-invalid">{errors.rfc}</div>}
                          {!errors.rfc && touched.rfc && <div className="field-valid">ok</div>}
                          <Field name="rfc" type="text" />
                        </div>
                        <div className="field -input">
                          <label htmlFor="email">Correo electrónico:</label>
                          {errors.email && touched.email && <div className="field-invalid">{errors.email}</div>}
                          {!errors.email && touched.email && <div className="field-valid">ok</div>}
                          <Field name="email" type="text" placeholder="correo@correo.com" />
                        </div>
                      </div>
                    </div>
                    <div className="form-buttons">
                      <Button
                        type="submit"
                        disabled={!isValid && !isValidating && !isSubmitting}
                        label="Continuar"
                        direction="forward" />
                    </div>
                  </Form>
                );
              }}
            </Formik>
          )
          : ''
      }
    </div>
  );
};

export default Form6;
